var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagIconDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19421 4C7.14393 4 6.19721 4.23519 5.31068 4.72146L5 4.89344V19.402C5 19.732 5.26805 20 5.59798 20C5.92792 20 6.19597 19.732 6.19597 19.402V13.6304C6.81038 13.3491 7.46537 13.2096 8.19421 13.2096C9.28804 13.2096 10.4282 13.5195 11.5831 13.8356L11.6005 13.8403C12.7667 14.1601 14.0239 14.5048 15.2873 14.5048C16.3376 14.5048 17.2843 14.2696 18.1708 13.7834L18.4815 13.6132V4.23705L17.5964 4.72218C16.8926 5.10765 16.1404 5.29605 15.2873 5.29605C14.1935 5.29605 13.0532 4.98612 11.8985 4.66931L11.881 4.6645C10.7148 4.34473 9.4576 4 8.19421 4ZM6.19597 12.3391V5.61534C6.81011 5.335 7.46506 5.1968 8.19421 5.1968C9.28799 5.1968 10.4283 5.50673 11.5831 5.82275L11.6005 5.82751C12.7667 6.14728 14.0239 6.49201 15.2873 6.49201C15.9955 6.49201 16.657 6.38491 17.2856 6.16578V12.8903C16.6714 13.1707 16.0165 13.3089 15.2873 13.3089C14.1935 13.3089 13.0532 12.9989 11.8985 12.6821L11.881 12.6773C10.7148 12.3575 9.4576 12.0128 8.19421 12.0128C7.486 12.0128 6.82457 12.1199 6.19597 12.3391Z",
    fill: "#B5B5B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIconDisabled);
export default __webpack_public_path__ + "static/media/flag-icon-disabled.dfeb45b25a7d99dda66af2a28f787dd5.svg";
export { ForwardRef as ReactComponent };